export default {
    fbAppId: '394937714627640'
};
